var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-name" },
    [
      _vm.applyType === "signList"
        ? [
            _vm.signInfo.status === 0 || _vm.signInfo.status === -1
              ? [
                  _vm.signInfo.selfSign === 1
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: { "font-sty": _vm.newFont },
                              on: {
                                click: function($event) {
                                  return _vm.toSign(
                                    _vm.signInfo.signNo,
                                    _vm.signInfo.approveId
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.signInfo.name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: { "font-sty": _vm.newFont },
                              on: {
                                click: function($event) {
                                  return _vm.toApplyDetail({
                                    applyNo: _vm.signInfo.applyNo,
                                    signNo: _vm.signInfo.signNo
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.signInfo.name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                ]
              : _vm.signInfo.status === 1 || _vm.signInfo.status === 4
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: { "font-sty": _vm.newFont },
                          on: {
                            click: function($event) {
                              return _vm.toApplyDetail({
                                applyNo: _vm.signInfo.applyNo,
                                signNo: _vm.signInfo.signNo
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.signInfo.name) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ]
              : _vm.signInfo.status === -5 || _vm.signInfo.status === 2
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: { "font-sty": _vm.newFont },
                          on: {
                            click: function($event) {
                              return _vm.toApplyDetail({
                                applyNo: _vm.signInfo.applyNo,
                                signNo: _vm.signInfo.signNo
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.signInfo.name) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ]
              : _vm.signInfo.status === -6
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: { "font-sty": _vm.newFont },
                          on: {
                            click: function($event) {
                              return _vm.$message.error("文件已过期")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
        : _vm.applyType === "applyList"
        ? [
            _vm.signInfo.status === 0
              ? [
                  _vm.signInfo.selfSign === 1
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: { "font-sty": _vm.newFont },
                              on: {
                                click: function($event) {
                                  return _vm.toSign(
                                    _vm.signInfo.signNo,
                                    _vm.signInfo.approveId
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    "" +
                                      _vm.signInfo.name +
                                      ([17, 20].includes(
                                        _vm.signInfo.row.applySignDealType
                                      )
                                        ? " (" +
                                          _vm.signInfo.row.businessNo +
                                          ")"
                                        : "")
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: _vm.signInfo.name,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: { "font-sty": _vm.newFont },
                              on: {
                                click: function($event) {
                                  return _vm.toApplyDetail({
                                    applyNo: _vm.signInfo.applyNo,
                                    signNo: _vm.signInfo.signNo
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.signInfo.name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                ]
              : _vm.signInfo.status === -6
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: { "font-sty": _vm.newFont },
                          on: {
                            click: function($event) {
                              return _vm.$message.error("文件已过期")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.signInfo.name))]
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.signInfo.name || _vm.signInfo.contractName,
                        placement: "bottom-start"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: { "font-sty": _vm.newFont },
                          on: {
                            click: function($event) {
                              return _vm.toApplyDetail({
                                applyNo: _vm.signInfo.applyNo,
                                signNo: _vm.signInfo.signNo
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.signInfo.name || _vm.signInfo.contractName
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ]
          ]
        : _vm._e(),
      _c("goto-auth", { attrs: { default: _vm.authDialog } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8408b9f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8408b9f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/contractName.vue
// module id = Q0wJ
// module chunks = 1 23 24 29 43 47 50